__turbopack_context__.v({
  "modal": "MobileFullScreenModalLayout-module-scss-module__WXsRQa__modal",
  "modal__content": "MobileFullScreenModalLayout-module-scss-module__WXsRQa__modal__content",
});
